import { render, staticRenderFns } from "./CardFooterImmo.vue?vue&type=template&id=4998933b&scoped=true&"
import script from "./CardFooterImmo.vue?vue&type=script&lang=js&"
export * from "./CardFooterImmo.vue?vue&type=script&lang=js&"
import style0 from "./CardFooterImmo.vue?vue&type=style&index=0&id=4998933b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4998933b",
  null
  
)

export default component.exports